import AppHeader from 'components/AppHeader/AppHeader';
import AppLocation from 'components/AppLocation';
import AppStatus from 'components/AppStatus';
import CardColumns from 'components/MobilityScreen/CardColumns';
import QRCodeModal from './QRCodeModal';
import ScrollArea from 'components/ScrollArea';
import TabBar from 'components/TabBar/TabBar';
import UpdateAnimation from 'components/UpdateAnimation';
import Updater from 'components/MobilityScreen/Updater';

import { useQRCodeModal } from '../../context/qrCodeModalContext';


function MobilityScreen({
	params,
	loading,
	updating,
	action,
	statusMessage,
	statusInstructions,
	statusContactSupport,
	isHub,

	userLocation,
	appLocation,

	address,
	customer,

	showAppStatus,
	selectedTab,

	setNavigation,
	updateApp,
	toggleTripScreen,
	onNavBarButtonClick,
	setCardFavorite,

	toggleCardScreen,
	openMappedIn,

	cards,
	screen,
	weather,
	alerts,

	showCardScreen,
	showTripScreen,

	shortCode

}) {

	const {
		key,
		header,
		menu,
		tripPlan,
		barPosition,
	} = params;

	const { qrUrl, route, text, hideQRCodeModal } = useQRCodeModal();

	return (
		<div className="MobilityScreen">
			<UpdateAnimation params={params} loading={loading} updating={updating} />

            {qrUrl && <QRCodeModal qrUrl={qrUrl} route={route} text={text} onClose={hideQRCodeModal} />}

			{key && (header || menu) ? <AppHeader
				updateApp={updateApp}
				userLocation={userLocation}
				appLocation={appLocation}
				setNavigation={setNavigation}
				menu={menu}
				screen={screen}
				address={address}
				weather={weather}
				customerApiKey={key} /> : null}

			<AppStatus
				showAppStatus={showAppStatus}
				params={params}
				action={action}

				statusMessage={statusMessage}
				statusInstructions={statusInstructions}
				statusContactSupport={statusContactSupport}

				// For error reporting
				customer={customer}
				screen={screen}
			/>

			<ScrollArea params={params}>

				{/* {tripPlan ? <TripPromoCard
					appLocation={appLocation}
					userLocation={userLocation}
					screen={screen}
					toggleTripScreen={toggleTripScreen} /> : null} */}

				<CardColumns
					toggleTripScreen={toggleTripScreen}
					toggleCardScreen={toggleCardScreen}
				openMappedIn={openMappedIn}

					appLocation={appLocation}
					userLocation={userLocation}

					action={action}
					params={params}
					selectedTab={selectedTab} // filters cards

					cards={cards}
					screen={screen}
					weather={weather}
					alerts={alerts}

					showCardScreen={showCardScreen}
					setCardFavorite={setCardFavorite}
					shortCode={shortCode}
				/>

				{/*<PoweredByAF />*/}

			</ScrollArea>

			{barPosition ? <TabBar
				params={params}
				selectedTab={selectedTab}
				isHub={screen !== undefined} //If there is a screen value, then user is in a hub zone, so all allowedModes and sortOrder follow screen's values
				onNavBarButtonClick={onNavBarButtonClick} /> : null}

			<AppLocation
				customer={customer}
				screen={screen}
				address={address}
				params={params}
				updateApp={updateApp} />

			<Updater
				params={params}
				appLocation={appLocation}
				updateApp={updateApp}
				showTripScreen={showTripScreen}
				shortCode={shortCode}
			/>
		</div>
	)

};

export default MobilityScreen
